<a [href]="article.url" class="article-card" [attr.data-variant]="variant" [class.long-title]="isLongTitle">
  <div class="card-image">
    <img [src]="article.imageUrl" [alt]="article.imageAlt || article.title" loading="lazy">
  </div>
  
  <div class="card-content">
    <!-- For 'browse' variant: date comes right after title -->
    <div *ngIf="variant === 'browse'" class="title-container">
      <h3 class="card-title">{{ article.title }}</h3>
      <time class="card-date" [attr.datetime]="article.publishedDate">
        {{ formattedDate }}
      </time>
    </div>
    
    <!-- For other variants: standard layout with title-date wrapper -->
    <div *ngIf="variant !== 'browse'" class="title-date-wrapper">
      <h3 class="card-title">{{ article.title }}</h3>
      <time class="card-date" [attr.datetime]="article.publishedDate">
        {{ formattedDate }}
      </time>
    </div>
    
    <!-- Hidden excerpt for non-browse variants -->
    <p *ngIf="variant !== 'browse'" class="card-excerpt">{{ truncatedExcerpt }}</p>
    
    <!-- Author section (ONLY for browse variant) -->
    <div *ngIf="variant === 'browse'" class="card-author browse-author">
      <img 
        *ngIf="article.author.avatarUrl" 
        [src]="article.author.avatarUrl" 
        [alt]="article.author.name"
        class="author-avatar"
        loading="lazy">
      <span class="author-name">{{ article.author.name }}</span>
    </div>
    
    <!-- Author section for non-browse variants -->
    <div *ngIf="variant !== 'browse'" class="card-author">
      <img 
        *ngIf="article.author.avatarUrl" 
        [src]="article.author.avatarUrl" 
        [alt]="article.author.name"
        class="author-avatar"
        loading="lazy">
      <span class="author-name">{{ article.author.name }}</span>
    </div>
  </div>
</a>

